import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import User from "@mapmycustomers/shared/types/User";
import { ModifiedMapFilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";

import { FILTER_ENTITY_TYPES } from "./consts";

const getAppliedMapFiltersCount = (
  filter: ModifiedMapFilterModel,
  viewAs: undefined | User["id"],
  implicitFilterFields?: IField[]
) => {
  const implicitFilterFieldsNames = new Set((implicitFilterFields ?? []).map(({ name }) => name));

  return FILTER_ENTITY_TYPES.reduce(
    (result, entityType) =>
      result +
      (filter[entityType]
        ? Object.keys(filter[entityType]!).filter(
            (fieldName) =>
              filter[entityType]![fieldName] !== undefined &&
              !implicitFilterFieldsNames.has(fieldName)
          ).length
        : 0),
    viewAs === undefined ? 0 : 1
  );
};

export default getAppliedMapFiltersCount;
